import { getAuthToken } from "../../../auth/authClient";

const API_BASE = (process.env.REACT_APP_MORFEUSZ_4E_API_URL || "").replace(/\/$/, "");
const avatarUrl = () => `${API_BASE}/profile/avatar`;

const authHeaders = (headers = {}) => {
  const token = getAuthToken();
  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    const error = new Error(data?.message || `avatar-http-${response.status}`);
    error.code = data?.code || `avatar-http-${response.status}`;
    error.status = response.status;
    throw error;
  }
  return data;
};

const request = async (options = {}) => {
  if (!API_BASE) {
    const error = new Error("avatar-api-missing");
    error.code = "avatar-api-missing";
    throw error;
  }

  const response = await fetch(avatarUrl(), {
    credentials: "include",
    ...options,
    headers: authHeaders(options.headers || {}),
  });
  return parseResponse(response);
};

export const avatarClient = {
  get: () => request({ method: "GET" }),
  upload: (file) => {
    const body = new FormData();
    body.append("avatar", file);
    return request({ method: "POST", body });
  },
  remove: () => request({ method: "DELETE" }),
};
